import { useAppSelector } from '@frontend/common';
import { ProductGroupConstraintData, isProductGroupConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ProductGroupConstraintDataInputProps } from './product-group-constraint-data-input.component';

interface ViewProps {
    formValues: ProductGroupConstraintData;
}

const useProductGroupConstraintDataInput = (props: ProductGroupConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isProductGroupConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { product_group_id: undefined } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useProductGroupConstraintDataInput;
